import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontMerriweather, fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";
import { EntityLink } from "scmp-app/components/entity-link";

export const PlaceholderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 274px;
  block-size: auto;

  background-color: #e2e2e2;
  aspect-ratio: 3/2;

  svg {
    inline-size: 80px;
    block-size: 64px;
    margin: auto;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  align-self: stretch;

  inline-size: 100%;
  block-size: 100%;
  max-inline-size: 300px;
  padding: 12px;

  border: 1px solid #cccccc;

  background: #ffffff;

  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Summary = styled.span`
  display: flex;
  gap: 4px;
  align-items: center;

  color: #000000;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Name = styled.span`
  color: #000000;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: 130%;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Description = styled.span`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 130%; /* 18.2px */
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Footer = styled.div`
  display: grid;
  grid:
    "description description" min-content
    "setup-btn preview" min-content
    / 1fr 1fr;
  row-gap: 8px;

  inline-size: 100%;
  margin-block-start: auto;
  padding: 8px;

  background-color: #f5f5f5;
`;

export const LongDescription = styled.span`
  grid-area: description;

  color: #000000;
  font-weight: 700;
  font-size: 11px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const SetUpNowButton = styled(BaseLink)`
  grid-area: setup-btn;

  align-self: self-end;

  inline-size: fit-content;
  block-size: fit-content;
  padding-block: 4px;
  padding-inline: 8px;

  color: #ffffff;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;

  border-radius: 2px;

  background-color: #4585ff;
`;

export const Preview = styled(EntityLink)`
  grid-area: preview;

  align-self: center;

  padding-inline: 8px;

  color: #333333;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  text-align: end;

  font-feature-settings:
    "liga" off,
    "clig" off;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const StyledBaseImage = styled(BaseImage)`
  inline-size: 100%;
  block-size: auto;
  aspect-ratio: 3/2;
`;
